import * as React from 'react'

import { ExternalSchool_externalSchool as IExternalSchool } from 'main/gql/externalSchool'
import { Modal } from 'main/ui'
import { Confirmation, RemoveForm } from './steps'

type Step = 'opening' | 'confirmation'

interface IProps {
  externalSchool: IExternalSchool
  onRequestClose: () => void
}

export default function RemoveModal(props: IProps) {
  const { externalSchool, onRequestClose } = props
  const [step, setStep] = React.useState<Step>('opening')

  return (
    <Modal title={title(step)} onRequestClose={onRequestClose}>
      {renderStepContent()}
    </Modal>
  )

  function renderStepContent() {
    switch (step) {
      case 'opening':
        return (
          <RemoveForm externalSchool={externalSchool} onComplete={() => setStep('confirmation')} />
        )

      case 'confirmation':
        return <Confirmation onComplete={() => onRequestClose()} />
    }
  }
}

function title(step: Step) {
  switch (step) {
    case 'opening':
      return 'De-list your program from the Wonderschool website'
    case 'confirmation':
      return 'Your request has been sent'
  }
}
